import { render, staticRenderFns } from "./productCollection.vue?vue&type=template&id=53f06e2f&scoped=true&"
import script from "./productCollection.vue?vue&type=script&lang=js&"
export * from "./productCollection.vue?vue&type=script&lang=js&"
import style0 from "./productCollection.vue?vue&type=style&index=0&id=53f06e2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f06e2f",
  null
  
)

export default component.exports